// chrome.exe --user-data-dir="C://Chrome dev session" --disable-web-security
//import Es6Promise from 'es6-promise'
//Es6Promise.polyfill()

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource'
import Vuelidate from 'vuelidate'
import VueI18n from 'vue-i18n'
import VS2 from 'vue-script2'


import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import messages from './assets/i18n.json'
require('./scss/default.scss')


Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(Vuelidate)
Vue.use(VueI18n)
Vue.use(VS2)

const i18n = new VueI18n({
  locale: 'de',
  messages
})

new Vue({
  i18n,
  router,
  render: h => h(App),
  async mounted() {
    const supported = (() => {
      const nav = navigator.userAgent.toLocaleLowerCase()
      const isNotIe9 = ((nav.indexOf('msie') != -1) ? parseInt(nav.split('msie')[1]) : 11) !== 9
      const supportSvg = !!(document.createElementNS && document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect)
      return isNotIe9 && supportSvg
    })();
    if (supported) {
      this.$router.replace("/")
    } else {
      this.$router.replace("/notsupported")
    }
  }

}).$mount('#app')

//console.log(router.app._route)
//router.replace('/')
